@use "styles" as *;
@use "sass:map";

$block: me-headline;

.#{$block} {
  display: block;

  &--inline {
    display: inline;
  }

  @each $variant, $options in $headlines {
    &--#{$variant} {
      margin-block-start: map.get($options, margin-block-start);
      margin-block-end: map.get($options, margin-block-end);

      .#{$block}__tag {
        font-size: map.get($options, font-size);
        font-weight: map.get($options, font-weight);
        text-transform: map.get($options, text-transform);

        /** There are no conditionals in CSS => Use $max-lines: 1440 to "disable" line clamping per default */
        @include lineClamp(1440, $line-height-base, map.get($options, font-size));
      }
    }
  }

  &--center &__tag {
    text-align: center;
  }

  &--chapter {
    background: $color-gray-100;
    padding: space(4, 3);
    border-left: space(2) solid $color-primary;
  }

  &--collection  {
    border-bottom: 1px solid $color-gray-300;
  }

  .me-section--secondary &--collection {
    border-bottom-color: $color-text;
  }

  &--inverse {
    color: $color-text-highlight;
    border-color: $color-text-highlight;
  }

  &--stripe {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;

    &::before, &::after {
      display: block;
      content: '';
      border-top: 1px solid;
      flex: 1 0 space(5);
    }

    &::before {
      margin-right: space(2);
    }

    &::after {
      margin-left: space(2);
    }
  }

  &--teaser *[slot=icon-left] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    vertical-align: top;
    transform: scale(calc(20 / 22.5)); // workaround for perfect vertical alignment
    transform-origin: left center;
    width: $me-headline-teaser-icon-size;
    height: $me-headline-teaser-icon-size;
    line-height: $me-headline-teaser-icon-size;
    color: $color-text-highlight;
    background-color: $color-primary;
  }

  &__tag {
    margin: 0;
  }

  &__link  {
    text-decoration: none;
    color: inherit;
  }
}
